<script setup lang="ts">
import ModalAllBalls from '~/components/pages/results/modals/ModalAllBalls.vue'
import BallsLottery from '~/components/pages/results/BallsLottery.vue'

defineOptions({
	name: 'BoxNumbers',
})

const props = defineProps({
	numbers: {
		type: Object,
		required: true,
	},
	isColor: {
		type: Boolean,
		default: true,
	},
	classContainerFirstBlock: {
		type: String,
		default: 'mx-auto flex flex-wrap smm:flex-nowrap justify-center items-center gap-x-1.5 gap-y-2.5',
	},
	classInput: {
		type: String,
		default: 'input-container',
	},
	showBtnDetail: {
		type: Boolean,
		default: true,
	},
})

const MAX_BALLS_DISPLAYED = 10
const MIN_BALLS_SHOW = 5

const showModalAllBalls = ref<boolean>(false)

const counterBalls = computed(() => {
	const { first, last = [] } = props.numbers
	return first.length + last?.length
})

const getFirstBlock = computed(() => {
	if (props.showBtnDetail && counterBalls.value > MAX_BALLS_DISPLAYED)
		return props.numbers.first.slice(0, MIN_BALLS_SHOW)
	return props.numbers.first
})
</script>

<template>
	<div>
		<div class="flex justify-center items-center gap-2">
			<BallsLottery
				:numbers="props.numbers"
				:first-block="getFirstBlock"
				:is-color="props.isColor"
				:class-container-first-block="props.classContainerFirstBlock"
				:class-input="props.classInput"
			/>
			<UButton
				v-if="props.showBtnDetail && counterBalls > MAX_BALLS_DISPLAYED"
				square
				leading
				color="white"
				variant="soft"
				:label="`+${counterBalls - MIN_BALLS_SHOW}`"
				:ui="{
					rounded: 'rounded-full',
				}"
				class="text-neutral-50 font-semibold leading-5 hover:no-underline hover:bg-primary-400 px-2.5 py-0.5 transition-all duration-300 w-max group"
				@click="showModalAllBalls = true"
			/>
		</div>
		<ModalAllBalls v-model="showModalAllBalls">
			<BallsLottery
				:numbers="props.numbers"
				:first-block="props.numbers.first"
				:is-color="props.isColor"
				class-container-first-block="mx-auto flex flex-wrap justify-center items-center gap-x-2.5 gap-y-2.5"
				:class-input="props.classInput"
				class="max-w-lg"
			/>
		</ModalAllBalls>
	</div>
</template>
